/**
 * Action proposed for an Underlying Instrument instance.
 * tag: 944
 * @readonly
 * @enum {number} (int)
 */
export enum CollAction {
  /** Retain */
  Retain = 0,
  /** Add */
  Add = 1,
  /** Remove */
  Remove = 2,
}
